import React, { FunctionComponent, useState } from 'react'
import { FaDropbox } from 'react-icons/fa'
import Dialog from '@material-ui/core/Dialog'
import moment from 'moment'

import '../styles/Item.scss'
import { DropboxData } from '../utils/SearchItem'
import Icon from './Icon'
import MatchingTerms from './MatchingTerms'

const DropboxItem: FunctionComponent<DropboxData> = (props) => {
  const [open, toggleOpen] = useState(false)

  const renderPopup = () => {
    const date = moment(new Date(props.created)).format('MMM D, YYYY')

    return (
      <Dialog open={open} onClose={() => toggleOpen(false)}>
        <div className='Item-popup'>
          <div className='Item-popup-header'>
            <Icon icon={FaDropbox} backgroundColor='#c3e9d7' />
            <p>{props.title}</p>
          </div>
          <div className='Item-popup-content'>
            <strong>
              <p>Path: </p>
            </strong>
            <p>"{props.path}"</p>
            {props.shared_with && (
              <>
                <strong>
                  <p>Shared with: </p>
                </strong>
                <ul>
                  {props.shared_with.map((user) => (
                    <li>{user}</li>
                  ))}
                </ul>
              </>
            )}

            <strong>
              <p>Created: </p>
            </strong>
            <p>{date}</p>
          </div>
          <MatchingTerms
            backgroundColor='#c3e9d7'
            terms={props.matching_terms}
          />
        </div>
      </Dialog>
    )
  }

  return (
    <>
      <div className='Item' onClick={() => toggleOpen(true)}>
        <Icon icon={FaDropbox} backgroundColor='#c3e9d7' />
        <p>{props.title}</p>
      </div>
      {renderPopup()}
    </>
  )
}

export default DropboxItem
